<template>
  <div class="table">
    <el-table
      :data="tdata"
      style="width: 100%"
      height="400"
      class="customer-table"
    >
      <el-table-column
        prop="flag"
        label="fileName"
        min-width="400"
        align="left"
      >
      </el-table-column>
      <el-table-column label="Detail" align="left">
        <template slot-scope="scope">
          <el-button size="small" @click="handleEdit(scope.$index, scope.row)"
            >Detail</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <el-dialog title="Hot Map" :visible.sync="dialogVisible" width="80%">
      <Chart
        chartName="gradient"
        chartHotname="HeatMap"
        v-if="gradient"
        :visData="gradient"
        :chartHotData="heat"
         style="margin-bottom: 20px;"
      ></Chart>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">Cancel</el-button>
        <el-button type="primary" @click="dialogVisible = false"
          >Confirm</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Chart from "../components/Chart.vue";

export default {
  name: "FileNameTable",
  props: ["tableId", "tdata"],
  data() {
    return {
      dialogVisible: false,
      gradient: null,
      heat: null,
    };
  },
  computed: {},
  methods: {
    handleEdit(index, row) {
      console.log(row);
      let params = {
        filename: row.filename,
        project: row.project,
        sample: row.sample,
        subtype: row.subtype,
      };
      this.getMaizeHot(params);
    },
    verticalSum(arr) {
      const n = arr[0].length;
      const result = new Array(n).fill(0);

      for (let i = 0; i < 4; i++) {
        for (let j = 0; j < n; j++) {
          result[j] += arr[i][j];
        }
      }

      return result;
    },
    convertToCustomFormat(array) {
      const result = [];

      for (let i = 0; i < array.length; i++) {
        for (let j = 0; j < array[i].length; j++) {
          result.push([j, i, array[i][j]]);
        }
      }

      return result;
    },
    async getMaizeHot(params) {
      let filename = params.filename;
      let result = await this.$API.reqMaizeHot(params);
      console.log(result[filename]);
      this.heat = this.convertToCustomFormat(result[filename]);
      this.gradient = this.verticalSum(result[filename]);
      this.dialogVisible = true;
    },
  },
};
</script>

<style scoped>
/* 去掉表格单元格边框 */
::v-deep.customer-table th {
  border: none;
}
::v-deep.customer-table td,
.customer-table th.is-leaf {
  border: none;
}
/* 表格最外边框 */
::v-deep.el-table--border,
.el-table--group {
  border: none;
}
/* 头部边框 */
/* ::v-deep.customer-table thead tr th.is-leaf{
    border: 1px solid #EBEEF5;
    border-right: none;
  } */
::v-deep.customer-table thead tr th:nth-last-of-type(2) {
  border-right: 1px solid #ebeef5;
}
/* 表格最外层边框-底部边框 */
::v-deep.el-table--border::after,
.el-table--group::after {
  width: 0;
}
::v-deep.customer-table::before {
  width: 0;
}
::v-deep.customer-table .el-table__fixed-right::before,
.el-table__fixed::before {
  width: 0;
}
/* 表格有滚动时表格头边框 */
::v-deep.el-table--border th.gutter:last-of-type {
  border: 1px solid #ebeef5;
  border-left: none;
}

/* .table {

  width: 100%;

  display: flex;

  flex-direction: column;
  }
  .table .el-table__body-wrapper {

  flex: 1;

  } */
</style>
